module.exports = __webpack_public_path__ + "media/fonts/PPNeueMontreal-Medium-f366d0cc.otf";